export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()

/**
 * Shape of a value that is an ENUM KEY rather than display text: lowercase alphanumerics,
 * `_` as the only separator. `waiting_on_customer`, `in_progress`, `month` — but not
 * `Louis Vuitton`, `iPhone case`, `Touch (~1 cm)` or `S/M`.
 */
const ENUM_KEY = /^[a-z0-9]+(?:_[a-z0-9]+)*$/

/**
 * Render a facet/option value as a label WITHOUT ever rewriting text that is already display text.
 *
 * The problem this solves: one renderer serves two different kinds of value. An enum key
 * (`waiting_on_customer`) genuinely wants `_`→space and a capital at the front; a display string
 * that arrived in its correct form (a company name, a person's name, a size) wants to be left
 * completely alone. The component cannot ask the value which it is, so it asks what the value
 * LOOKS like, and only transforms the unambiguous case.
 *
 * The gate is deliberately conservative — a value is only touched if it contains no uppercase,
 * no whitespace and no punctuation beyond `_`, i.e. a shape no human-authored display string
 * has. Every proper noun therefore falls through untouched, which is the failure that gets
 * noticed: the previous implementation ran everything through `capitalize`, whose second half
 * LOWER-CASES the remainder, and printed "Louis Vuitton" back at a Vera staffer as
 * "Louis vuitton". Erring the other way is cheap — an untransformed key reads slightly raw;
 * a mangled customer name reads as a bug.
 *
 * Note the `/g`: `waiting_on_customer` has TWO underscores. A non-global replace produced
 * "Waiting on_customer".
 */
export const formatEnumLabel = (value: string): string => {
  const trimmed = value.trim()
  if (!ENUM_KEY.test(trimmed)) return trimmed
  const spaced = trimmed.replace(/_/g, ' ')
  return spaced.charAt(0).toUpperCase() + spaced.slice(1)
}

export const getFileExtension = (fileName: string) => {
  const parts = fileName.split('.')
  return parts[parts.length - 1]
}

export const toTitleCase = (str) => {
  return str.replace(/\b\w+/g, function (s) {
    return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase()
  })
}
